module.exports = __webpack_public_path__ + "img/background3-mobile-hk.56aeff88.jpg";